export const QR_CODE_EXAMPLE_1 =
  'https://duckduckgo.com/?q=qr+code+%22%7B%22sender%22%3A+%22IKEA+BV%22%2C+%22invoice_no%22%3A+%222020000042%22%2C+%22description%22%3A+%22Kallax%22%2C+%22amount%22%3A+59.95%2C+%22vat%22%3A+%5B+%7B+%22rate%22%3A+21%2C+%22amount%22%3A+10.4+%7D+%5D+%7D%22&ia=answer';
